import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ServiceService } from './services/service.service';

@Injectable({
  providedIn: 'root'
})
export class IdleTimeoutService {
  private user_id: any;
  private timeout: any;
  private idleTime = 60 * 60 * 1000; // 10 minutes

  constructor(private router: Router, private auth: AuthService, private ngZone: NgZone, private ServerService: ServiceService) {

    this.user_id = localStorage.getItem('user_name');

  }

  startWatching() {
    this.resetTimer();
    ['mousemove', 'keydown', 'click'].forEach(evt =>
      window.addEventListener(evt, () => this.resetTimer())
    );
  }

  resetTimer() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.logout(), this.idleTime);
  }

  logout() {
    this.auth.logout();
    this.log_details();
    this.router.navigate(['/login']);
  }

  log_details() {
    const api_req: any = {
      action: "logout",
      phone_number: this.user_id

    };


    this.ServerService.sendzohoServer(api_req).subscribe((response: any) => {
      if (response.success == true || response.success == "true") {
        // success handling
       // console.log("Logout saved successfully");
      } else {
        // error handling
        console.error("Logout saving failed");
      }
    });
  }
}
